import { render, staticRenderFns } from "./AccountDataDetails.vue?vue&type=template&id=77c22e8a&scoped=true"
import script from "./AccountDataDetails.vue?vue&type=script&lang=js"
export * from "./AccountDataDetails.vue?vue&type=script&lang=js"
import style0 from "./AccountDataDetails.vue?vue&type=style&index=0&id=77c22e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c22e8a",
  null
  
)

export default component.exports